import React from 'react';
import { useLocation } from 'react-router-dom';
import MuiDropdown from './UI/MuiDropDown';
import useBook from './hooks/books/useBook';

const AllVocabulary = ({ type, tabSelector, onManageVocabMenu, unitExists= false }) => {
    const location = useLocation();
    
    const items = [
        {
            key: 'page_vocabulary',
            label: 'Page Vocab'
        },
        ...(location.pathname === "/ebook"  &&  unitExists ? [{
            key: "unit_vocabulary",
            label: "Unit Vocab",
        }] : [])
    ];

    const handleVocabMenuClick = (key) => {
        onManageVocabMenu(key, type);
    };

    return (
        <MuiDropdown
            items={items}
            onItemClick={handleVocabMenuClick}
            selectedValue={tabSelector?.type}
            defaultLabel="Page Vocab"
            className={`minWith ${tabSelector?.type === "page_vocab" || tabSelector?.type === "unit_vocabulary" ? 'selected selected-background-color' : ''}`}
        />
    );
};

export default AllVocabulary; 